import styled from "styled-components";

export const Link = styled.a`
  color: #0075c9;
  text-decoration: none;
  word-break: break-word;

  &:hover {
    text-decoration: underline;
  }
`;
